import { create } from "zustand";

const qcCityInfoStore = create((set, get) => ({
  cityInfos: {},
  setCityInfoPoint: (playerId, point) => {
    if (get().cityInfos[playerId] == null) {
      set((state) => ({
        cityInfos: {
          ...state.cityInfos,
          [playerId]: {
            point: point,
            blood: 0
          },
        },
      }));
    } else if (get().cityInfos[playerId].point == point) {
      return;
    } else {
      set((state) => ({
        cityInfos: {
          ...state.cityInfos,
          [playerId]: {
            ...state.cityInfos[playerId],
            point: point
          }
        },
      }));
    }
  },
  setCityInfoBlood: (playerId, blood) => {
    if (get().cityInfos[playerId] == null) {
      set((state) => ({
        cityInfos: {
          ...state.cityInfos,
          [playerId]: {
            point: 0,
            blood: blood
          },
        },
      }));
    } else if (get().cityInfos[playerId].blood == blood) {
      return;
    } else {
      set((state) => ({
        cityInfos: {
          ...state.cityInfos,
          [playerId]: {
            ...state.cityInfos[playerId],
            blood: blood
          }
        },
      }));
    }
  },
}));

export default qcCityInfoStore;
